
import { pp/* , pp_user, app_state, notify */ } from '@helpers'

import { appStore } from "@stores";

export const useShopStore = {

    state: ()/* : State */ => ({

        form: {},

    }),

    getters: {

        // getXXX(){
        //     return (status) => {
        //         return
        //     }
        // },
    },

    actions: {

        setShop(shop){
            if( ! shop){ shop = {} } // for Create


            shop = {
                ...shop,

                id:             shop.id             ?? null,
                label:          shop.label          ?? '',
                sap:            shop.sap            ?? null,
                business_id:    shop.business_id    ?? null,
                // emails:         shop.emails         ?? [],
                users_ids:      shop.users_ids      ?? [],
                contact:        shop.contact        ?? '',
                address:        shop.address        ?? '',
                description:    shop.description    ?? '',
                phone:          shop.phone          ?? '',
                latitude:       shop.latitude       ?? null,
                longitude:      shop.longitude      ?? null,

                add_user_after_store: false,
            }

            return shop
        },


        // for Edit and Create
        initForm(shop){

            shop = this.setShop(shop)

            if(pp().result){ // lors de la création d'une entreprise, on arrive directement ici, avec l'id de l'entreprise dans 'result' (@see BusinessController@store() )
                shop.business_id = pp().result
            }

            this.form = proto.$inertia.form(shop)

            // log('in stores/colis @initForm()',this.form)
        },

        // for Edit (in Index) and Create
        submit(){

            var router = this.form.id ? route('shop.update', this.form.id) : route('shop.store')

            // const formDatas = this.form.data()

            this.form
                // .transform(data => ({
                //     ...data,
                // }))
                [this.form.id ? 'put' : 'post'](router, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset();

                        appStore().getAllUsers(true)
                    },
                });
        },

    }
}
